/* eslint-disable react/prop-types */
import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Components
import Icon from './oc-icon';
import ImageAttribution from './oc-image-attribution';
import ImageShareLinks from './oc-image-share-links';
import Picture from './oc-picture';
import WrapperLink from './oc-wrapper-link';
import Theme from '../../themes/index';

// PB-1692: The `flex-direction` property here visually renders the media for the card first,
// while the heading & content that describe it are actually first in the DOM to be read and
// accessed first by assistive tech for better accessibility.
const Container = styled.div`
  display: inline-flex;
  flex-direction: column-reverse;
  position: relative;
  width: 100%;
`;

const Content = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
`;

const Media = styled.div`
  margin-bottom: 8px;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    width: 100%;
  }
`;

const IconWrapper = styled.div`
  align-items: center;
  background: white;
  bottom: 0;
  color: ${Theme.colors.brand};
  display: flex;
  font-size: 21px;
  height: 42px;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 42px;
`;

const StyledAttribution = styled(ImageAttribution)`
  @media screen and (min-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const Card = ({
  img,
  alt,
  attribution,
  url,
  icon,
  analytics,
  children,
  aspectRatio,
  linkText,
  transform = 'cards',
  socialShare,
  ctaSwitch,
  handleCtaButtonClick,
  'data-track': dataTrack,
  'data-track-destination': dataTrackDestination,
  ...props
}) => {
  if (aspectRatio) {
    aspectRatio.custom = aspectRatio.custom?.toString();
  }

  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <Container {...props}>
      <Content>{children}</Content>

      <WrapperLink
        url={url}
        tabIndex="-1"
        analytics={analytics}
        data-track={dataTrack}
        data-track-destination={dataTrackDestination}
      >
        {img && (
          <Media>
            {icon && (
              <IconWrapper>
                <Icon type={icon} />
              </IconWrapper>
            )}

            <Picture
              source={img}
              transform={transform}
              aspectRatio={aspectRatio}
              alt={alt}
              {...(!!ctaSwitch && { onClick: handleCtaButtonClick })}
            />

            {socialShare && <ImageShareLinks imageUrl={img} />}
            <StyledAttribution copy={attribution} />
          </Media>
        )}
      </WrapperLink>
    </Container>
  );
};

export default Card;
